import { JustpayFiscalEndpointService } from "@/views/loyalty/shared/endpoint_services/justpay-fiscal-endpoint-service"

export class JustpayFiscalService {
    constructor () {
        this.justpayFiscalEndpointService = new JustpayFiscalEndpointService()
    }

    async getList (arg) {
        return this.justpayFiscalEndpointService.getList(arg)
    }

    async getForFiltering () {
        const fiscals = await this.justpayFiscalEndpointService.getForFiltering()
        return fiscals || []
    }
}
